import {Link} from "react-router-dom";
import {formatDate, readTime} from "../../utils/blog.constants";
import ImageWithLoader from "../image-loader/image-with-loader.component";
import "./blog-card.styles.scss";

const BlogCard = ({post, featured = false}) => {
  const {slug, title, excerpt, coverImage, tags = [], createdAt, content} = post;

  return (
    <Link
      to={`/blog/${slug}`}
      className={`blog-card ${featured ? "featured" : ""}`}
    >
      {coverImage && (
        <div className="blog-card-image">
          <ImageWithLoader src={coverImage} alt={title}/>
        </div>
      )}

      <div className="blog-card-body">
        {tags.length > 0 && (
          <div className="blog-card-tags">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="blog-tag">
                {tag}
              </span>
            ))}
          </div>
        )}

        <h3 className="blog-card-title">{title}</h3>
        {excerpt && <p className="blog-card-excerpt">{excerpt}</p>}

        <div className="blog-card-meta">
          <span>{formatDate(createdAt)}</span>
          <span className="dot">·</span>
          <span>{readTime(content)} min read</span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
